import { Component, OnInit, Input, ElementRef, OnChanges } from '@angular/core';
import { ISortOptions, EOrderType, IPaginationOptions } from '../../core/ISortOptions';
import { ResultErrorsComponent } from '../result-errors/result-errors.component';
import { EJobType } from '../job-type.enum';
import { JobsService } from '../jobs.service';
import { BzgModalService } from 'bz-genome-angular';
import { IFilterColumn } from '../IFilterColumn';
import { IJobLog, IJobLogsResult } from '../IJob';

@Component({
  selector: 'job-execution',
  templateUrl: './job-execution.component.html',
  styleUrls: ['./job-execution.component.scss']
})
export class JobExecutionComponent implements OnChanges {

  @Input() jobType: EJobType;
  @Input() jobId = -1;
  @Input() userJobGuid = '';

  public showOnlyErrors = false;
  public isLoadingJobLogs = false;
  public jobLogs: Array<IJobLog>;
  public jobLogsTotal: number;
  public paginationOptions: IPaginationOptions;
  public sortOptions: ISortOptions = { columnName: 'id', orderType: EOrderType.asc };

  public columns: Array<IFilterColumn> = [
    { key: 'id', value: 'GLOBAL.ID', visible: true, type: 'text' },
    { key: 'jobExecutionDate', value: 'JOBS.EXECUTION_DATE', visible: true, type: 'date' },
    { key: 'jobExecutionResult', value: 'JOBS.EXECUTION_RESULT', blocked: true, visible: true, type: 'boolean' },
    { key: 'jobExecutionMessage', value: 'JOBS.EXECUTION_MESSAGE', visible: true, type: 'result' }
  ];
  constructor(private _jobsService: JobsService, private _modalService: BzgModalService, private _elemntRef: ElementRef) { }

  ngOnChanges() {
    this._loadJobLogs();
  }

  public async sortByColumn(columnName: string, orderType: number) {
    this.sortOptions.columnName = columnName;
    this.sortOptions.orderType = orderType;
    const queryParams = {
      orderColumn: this.sortOptions.columnName,
      orderType: this.sortOptions.orderType,
      currentPage: this.paginationOptions ? this.paginationOptions.currentPage : 1,
      limit: this.paginationOptions ? this.paginationOptions.pageSize : 10
    }
    if (this.showOnlyErrors) {
      queryParams['executionResult'] = false;
    }
    this._loadJobLogs(queryParams);
  }

  private async _loadJobLogs(queryParams = {}) {
    if (!this.jobType || (this.jobId < 0 && !this.userJobGuid)) {
      this.jobLogs = [];
      this.jobLogsTotal = 0;
      return;
    }
    this.isLoadingJobLogs = true;
    let jobLogsResult: IJobLogsResult;
    switch (this.jobType) {
      case EJobType.User:
        jobLogsResult = await this._jobsService.getUserJobLogsByGuid(this.userJobGuid, queryParams);
        break;
      default:
        jobLogsResult = await this._jobsService.getJobLogsById(this.jobId, queryParams);
        break;
    }
    this.jobLogs = jobLogsResult.values;
    this.jobLogsTotal = jobLogsResult.totalValues;
    this.isLoadingJobLogs = false;
  }

  public async onPaginationEvent(event) {
    this.paginationOptions = { currentPage: event.pageIndex + 1, pageSize: event.pageSize };
    const queryParams = {
      orderColumn: this.sortOptions.columnName,
      orderType: this.sortOptions.orderType,
      currentPage: this.paginationOptions.currentPage,
      limit: this.paginationOptions.pageSize
    }
    if (this.showOnlyErrors) {
      queryParams['executionResult'] = false;
    }
    this._loadJobLogs(queryParams);
  }

  public applyErrorFilter() {
    const queryParams = {
      orderColumn: this.sortOptions.columnName,
      orderType: this.sortOptions.orderType,
      currentPage: this.paginationOptions ? this.paginationOptions.currentPage : 1,
      limit: this.paginationOptions ? this.paginationOptions.pageSize : 10
    }
    if (this.showOnlyErrors) {
      queryParams['executionResult'] = false;
    }
    this._loadJobLogs(queryParams);
  }

  public openMessageModal(errorMessage: string) {
    this._modalService.open(ResultErrorsComponent, {
      closeOnBackdropClick: true,
      closeOnRouterNavigation: true,
      data: {
        title: 'JOBS.JOB_MESSAGE',
        message: errorMessage
      }
    });
  }

}
